import { Tabs, styled } from '@mui/material'

export const StyledTabs = styled(Tabs)(() => ({
  height: '100%',
  flexContainer: {
    height: '100%',
  },
}))
